'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SiteId$() {
  this.cca = null;
  this.ccb = false;
  this.cc8 = null;
  this.cc9 = false;
}
export { $c_Lpresto_types$SiteId$ as $c_Lpresto_types$SiteId$ };
$p = $c_Lpresto_types$SiteId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SiteId$;
/** @constructor */
function $h_Lpresto_types$SiteId$() {
}
export { $h_Lpresto_types$SiteId$ as $h_Lpresto_types$SiteId$ };
$h_Lpresto_types$SiteId$.prototype = $p;
$p.sQ = (function() {
  if ((!this.ccb)) {
    this.cca = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j9;
    this.ccb = true;
  }
  return this.cca;
});
$p.iS = (function() {
  if ((!this.cc9)) {
    this.cc8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().e1;
    this.cc9 = true;
  }
  return this.cc8;
});
var $d_Lpresto_types$SiteId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SiteId$, "presto.types$SiteId$", ({
  a1U: 1,
  D: 1
}));
export { $d_Lpresto_types$SiteId$ as $d_Lpresto_types$SiteId$ };
var $n_Lpresto_types$SiteId$;
function $m_Lpresto_types$SiteId$() {
  if ((!$n_Lpresto_types$SiteId$)) {
    $n_Lpresto_types$SiteId$ = new $c_Lpresto_types$SiteId$();
  }
  return $n_Lpresto_types$SiteId$;
}
export { $m_Lpresto_types$SiteId$ as $m_Lpresto_types$SiteId$ };
//# sourceMappingURL=presto.types$-Site-Id$.js.map
